// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3lcBo","footer":"ModalInfo_footer__1v2SV"};